'use client';
import React from 'react';
import clsx from 'clsx';
import { DevelocityLogo } from '@/components/Logos';
import { ModalVideoPlayer } from '@/components/ModalVideoPlayer';
import { PlayCircleIcon } from '@heroicons/react/20/solid';
interface WeclomeHeroProps {
  className: string;
}

const WelcomeHero = ({ className }: WeclomeHeroProps) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  return (
    <div
      className={clsx(
        'group relative flex h-96 flex-col overflow-hidden rounded-2xl px-4 py-8 text-white hover:cursor-pointer md:px-8',
        className,
      )}
      onClick={openModal}
    >
      <video autoPlay muted loop playsInline className="z-4 absolute inset-0 h-full w-full object-cover">
        <source src="/assets/videos/demoPage_heroBG.webm" type="video/webm" />
        <source src="/assets/videos/demoPage_heroBG.mp4" type="video/mp4" />
      </video>
      {/* Gradient Overlay */}
      <div className="z-1 absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-[#010002] to-transparent"></div>
      </div>
      <div className="z-10 mb-auto w-48 rounded-lg border border-gray-2 border-opacity-80 bg-gray-1 p-2">
        <DevelocityLogo monochrome />
      </div>
      <div className="flex max-w-[25rem] flex-col gap-2 md:max-w-[31rem]">
        <h1 className="text-h3 z-10">
          Take a Tour <br /> of Develocity
        </h1>
        <p className="text-body z-10">
          Learn how Develocity® solves developer pain points such as slow builds/tests, troubleshooting, and flaky
          tests.
        </p>
      </div>
      <div className="z-10">
        <button onClick={openModal} className="text-body group mt-4 flex w-fit items-center gap-2">
          <PlayCircleIcon className="mt-0.5 size-5 text-gradle-blue" />
          <span className="text-body underline-text-transition-blue">Watch the 2-min explainer</span>
        </button>
        <ModalVideoPlayer
          isOpen={isOpen}
          videoLink="https://gradleinc.wistia.com/medias/3ikit0em21"
          onClose={closeModal}
        />
      </div>
    </div>
  );
};

export default WelcomeHero;
